import { normalizeOrderPaymentMethod, orderPaymentMethodIsPartOrPlanSepare } from './orderPaymentTransactionRules'

/** Pagos en snapshot de listado o detalle (API puede enviar en raíz o en extraDetails). */
export function getPagosFromOrderSnapshot(order: {
  pagos?: Array<{ metodo_pago?: string }>
  extraDetails?: { pagos?: Array<{ metodo_pago?: string }> }
}): Array<{ metodo_pago?: string; id_transaccion?: string; id?: number }> {
  const fromExtra = order.extraDetails?.pagos
  const fromRoot = order.pagos
  if (Array.isArray(fromExtra) && fromExtra.length > 0) return fromExtra
  if (Array.isArray(fromRoot) && fromRoot.length > 0) return fromRoot
  return []
}

/**
 * Pedido con Bold a nivel principal o con algún tramo Bold en pagos parciales / plan separe.
 */
export function orderInvolvesBold(order: {
  payment_method?: string
  extraDetails?: { payment_method?: string; pagos?: Array<{ metodo_pago?: string }> }
  pagos?: Array<{ metodo_pago?: string }>
}): boolean {
  const main = normalizeOrderPaymentMethod(
    order.payment_method || order.extraDetails?.payment_method
  )
  if (main === 'bold') {
    return true
  }
  const pagos = getPagosFromOrderSnapshot(order)
  return pagos.some((p) => normalizeOrderPaymentMethod(p.metodo_pago) === 'bold')
}

export function orderNeedsPagosDetailForBoldVerify(order: {
  payment_method?: string
  extraDetails?: { payment_method?: string }
}): boolean {
  const main = normalizeOrderPaymentMethod(
    order.payment_method || order.extraDetails?.payment_method
  )
  return orderPaymentMethodIsPartOrPlanSepare(main)
}
